import clsx from 'clsx';
import { Barcode } from 'lucide-react';
import GenerateBarcode from '../../utils/GenerateBarcode';

export const PikkoJackpotBarcodeSection = ({ checkoutBarcode, showBarcode, setShowBarcode }) => (
  <div className='w-full rounded-2xl bg-gray-100 overflow-hidden transition-all duration-500 ease-in-out'>
    <button
      type="button"
      className='w-full flex items-center gap-4 p-6 active:bg-gray-200 transition-colors duration-150'
      onClick={() => setShowBarcode(prev => !prev)}
    >
      <div className='w-12 h-12 rounded-xl bg-gray-200 flex items-center justify-center shrink-0'>
        <Barcode size={22} className='text-gray-500' strokeWidth={2} />
      </div>
      <div className='flex flex-col items-start flex-1 min-w-0'>
        <span className='text-[15px] font-semibold text-gray-800'>Code de sortie</span>
        <span className='text-[13px] text-gray-500'>Présente-le à l'hôtesse</span>
      </div>
      <span className='text-[14px] font-medium text-gray-500 bg-gray-200 px-4 py-2 rounded-xl shrink-0'>
        {showBarcode ? 'Masquer' : 'Afficher'}
      </span>
    </button>
    <div
      className={clsx(
        'grid transition-all duration-500 ease-in-out',
        showBarcode ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0',
      )}
    >
      <div className='overflow-hidden'>
        <div className='flex justify-center px-4 pb-4 pt-2'>
          <GenerateBarcode value={checkoutBarcode} />
        </div>
      </div>
    </div>
  </div>
);
